import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCar5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCar5"><Path d="M19.75 17.5H22.5V13.0708C22.5 12.0611 22.1182 11.0888 21.4312 10.349L17.1869 5.77819C16.43 4.96313 15.368 4.5 14.2557 4.5H3.5L1.5 17.5H4.25" stroke="currentColor"/><Circle cx="7" cy="17" r="2.5" stroke="currentColor"/><Circle cx="17" cy="17" r="2.5" stroke="currentColor"/><Path d="M9.75 17.5H14.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconCar5;
